// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__39y_U","addWidgetButton":"Header_addWidgetButton__1XRd0","dashboardTabs":"Header_dashboardTabs__n6UqW","active":"Header_active__2dOKN"};